<template>
	<div>

		<!-- Begin Nav Sidebar (Drawer) -->
		<v-navigation-drawer
			v-model="drawer"
			:mini-variant.sync="drawerMini"
			:clipped="!isMobile"
			app
			:permanent="!isMobile"
			:temporary="isMobile"
			width="200"
		>

			<v-list-item-content class="d-flex d-sm-none">
				<v-list-item-title class="title px-3 py-1">
				 <img v-show="!$vuetify.theme.dark" src="/images/logo.png" style="max-width: 125px; height: auto;" />
				 <img v-show="$vuetify.theme.dark" src="/images/logo-dark.png" style="max-width: 125px; height: auto;" />
				 <div class="float-right clickable grey--text" @click.stop="drawer = false">&#10006;</div>
				</v-list-item-title>
			</v-list-item-content>

			<v-divider class="d-flex d-sm-none"></v-divider>

			<v-list nav dense class="mt-2">

				<v-list-item :to="{name: 'AppHome'}" link class="nav-draw-link">
					<v-list-item-icon class="drawer-link-icon">
						<v-icon>mdi-wallet-outline</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>{{ $t('nav.myTokens') }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="{ name: 'Marketplace'}" link class="nav-draw-link">
					<v-list-item-icon class="drawer-link-icon">
						<v-icon>mdi-shopping-outline</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>{{ $t('nav.marketplace') }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="{name: 'NewOrder'}" link class="nav-draw-link">
					<v-list-item-icon class="drawer-link-icon">
						<v-icon>mdi-cart-minus</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>{{ $t('nav.createNewOrder') }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="{ name: 'MyOrders', params: { orderType: 'sent' }}" link class="nav-draw-link">
					<v-list-item-icon class="drawer-link-icon">
						<v-icon>mdi-cart-arrow-up</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>{{ $t('nav.myOrders') }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="{ name: 'OrdersForMe', params: { orderType: 'received' }}" link class="nav-draw-link">
					<v-list-item-icon class="drawer-link-icon">
						<v-icon>mdi-cart-arrow-down</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>{{ $t('nav.ordersForMe') }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="{ name: 'TradeHistory' }" link class="nav-draw-link">
					<v-list-item-icon class="drawer-link-icon">
						<v-icon>mdi-history</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>{{ $t('nav.tradeHistory') }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="{name: 'HelpApp'}" link class="nav-draw-link">
					<v-list-item-icon class="drawer-link-icon">
						<v-icon>mdi-help-circle-outline</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>{{ $t('nav.help') }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="{name: 'Logout'}" link class="nav-draw-link">
					<v-list-item-icon class="drawer-link-icon">
						<v-icon>mdi-logout-variant</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>{{ $t('nav.logout') }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-divider class="mt-3"></v-divider>

				<v-list-item flat class="d-none d-sm-flex nav-draw-link mt-3">
					<v-list-item-icon v-show="drawerMini"
						class="drawer-link-icon" @click.stop="drawerMini = !drawerMini">
						<v-icon color="primary">mdi-chevron-double-right</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
					</v-list-item-content>
					<v-list-item-action v-show="!drawerMini"
						@click.stop="drawerMini = !drawerMini">
						<v-btn icon>
							<v-icon color="primary">mdi-chevron-double-left</v-icon>
						</v-btn>
					</v-list-item-action>
				</v-list-item>

			</v-list>

		</v-navigation-drawer>
		<!-- End Nav Sidebar (Drawer) -->

		<!-- Begin Top Navbar -->
		<v-app-bar
			color="black"
			dark
			app
			flat
			:clipped-left="!isMobile"
		>
			<v-app-bar-nav-icon v-if="!isMobile" class="" @click.stop="drawerMini = !drawerMini" style="margin-top: 2px"></v-app-bar-nav-icon>
			<v-app-bar-nav-icon v-if="isMobile" class="" @click.stop="drawer = !drawer" style="margin-top: 2px"></v-app-bar-nav-icon>
			<img src="/images/logo-dark.png" style="height: 35px; width: auto; margin-top: 2px" />

			<v-spacer></v-spacer>

			<!-- Testnet Name -->
			<v-toolbar-items v-if="!isMobile && network && network.name && network.id !== 1">
				<v-chip
					class="mt-4 mr-2 ml-2"
					color="orange"
					text-color="white"
				>
					<v-avatar left><v-icon small>mdi-lan</v-icon></v-avatar>
					{{ network.name }}
				</v-chip>
			</v-toolbar-items>

			<!-- My Tokens -->
			<v-toolbar-items v-if="!isMobile">
				<v-btn small text>
					<router-link class="navbar-link" :to="{name: 'AppHome'}">{{ $t('nav.myTokens') }}</router-link>
				</v-btn>
			</v-toolbar-items>

			<!-- Trade -->
			<v-menu v-if="!isMobile" offset-y bottom>
				<template v-slot:activator="{ on }">
					<v-btn small text v-on="on" class="navbar-link">
						{{ $t('nav.trade') }}
					</v-btn>
				</template>

				<v-list dense nav>

					<v-list-item dense :to="{ name: 'Marketplace' }">
						<v-list-item-content>
							<v-list-item-title >
								{{ $t('nav.marketplace') }}
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item dense :to="{ name: 'NewOrder' }">
						<v-list-item-content>
							<v-list-item-title >
								{{ $t('nav.createNewOrder') }}
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item dense :to="{ name: 'MyOrders', params: { orderType: 'sent' }}">
						<v-list-item-content>
							<v-list-item-title >
								{{ $t('nav.myOrders') }}
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item dense :to="{ name: 'MyOrders', params: { orderType: 'received' }}">
						<v-list-item-content>
							<v-list-item-title>
								{{ $t('nav.ordersForMe') }}
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item dense :to="{ name: 'TradeHistory'}">
						<v-list-item-content>
							<v-list-item-title >
								{{ $t('nav.tradeHistory') }}
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

				</v-list>

			</v-menu>

			<!-- Help -->
			<v-toolbar-items v-if="!isMobile">
				<v-btn small text>
					<router-link class="navbar-link" :to="{name: 'HelpApp'}">{{ $t('nav.help') }}</router-link>
				</v-btn>
			</v-toolbar-items>

			<!-- Settings -->
			<v-menu offset-y bottom>
				<template v-slot:activator="{ on }">
					<v-btn icon v-on="on">
						<v-icon>mdi-settings</v-icon>
					</v-btn>
				</template>
				<v-list dense nav>
					<v-list-item dense>
						<v-list-item-title>
							{{ $t('nav.darkMode') }}:
							<v-icon v-if="darkMode" class="ml-2" large @click="switchDarkMode">mdi-toggle-switch</v-icon>
							<v-icon v-else class="ml-2" large @click="switchDarkMode">mdi-toggle-switch-off-outline</v-icon>
						</v-list-item-title>
					</v-list-item>

					<v-list-item dense>
						<v-list-item-content style="max-width: 120px;">
							<v-list-item-title>{{ $t('common.noun.language') }}:</v-list-item-title>
							<div
							v-for="item in config.i18n"
							:key="item.locale" :value="item.locale"
							@click="setLocale(item.locale)"
							class="ml-3 mt-1">
								<span v-if="item.locale === locale">
									<v-icon>mdi-checkbox-marked</v-icon>
								</span>
								<span v-else>
									<v-icon>mdi-checkbox-blank-outline</v-icon>
								</span>
								<small class="ml-2">{{item.langDisplay}}</small>
							</div>
						</v-list-item-content>
					</v-list-item>

					<v-list-item dense>
						<v-list-item-title>
							{{ $t('common.noun.version') }}: {{ config.VERSION }}
						</v-list-item-title>
					</v-list-item>

				</v-list>
			</v-menu>

			<!-- User -->
			<v-menu offset-y bottom>
				<template v-slot:activator="{ on }">
					<v-btn icon v-on="on">
						<v-icon>mdi-account-circle</v-icon>
					</v-btn>
				</template>

				<v-list dense>

					<v-list-item dense>
						<v-list-item-icon class="drawer-link-icon">
							<v-icon>mdi-account</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title v-if="network.userAccount">
								<UserAddress :address="network.userAccount" nopopup></UserAddress>
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item v-if="config.linkToOldVersion"
					href="https://app-v2.ledgerdex.com" target="_blank" link dense>
						<v-list-item-icon class="drawer-link-icon">
							<v-icon>mdi-open-in-new</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title>
								{{ $t('common.phrase.visitOldVersion') }}
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item :to="{name: 'Logout'}" dense>
						<v-list-item-icon class="drawer-link-icon">
							<v-icon>mdi-logout-variant</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title>
								{{ $t('nav.logout') }}
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

				</v-list>

			</v-menu>

		</v-app-bar>
		<!-- End Top Navbar -->

	</div>
</template>

<script>
import { config } from '@/config'
import UserAddress from "@/components/UserAddress"
import {mapActions, mapGetters, mapState} from 'vuex'
export default {
	data () {
		return {
			config: config,
			drawer: true,
			drawerMini: false,
			darkMode: false,
			locale: null,
			langDisplay: '',
		}
	},
	components: {
		UserAddress
	},
	computed: {
		...mapGetters({
			network: 'getNetwork',
		}),
		isMobile: function () {
			return this.$vuetify.breakpoint.xsOnly
		}
	},
	methods: {
		checkDarkMode () {
			const localConfig = localStorage.getItem(config.localStorageKey.darkMode)
			if (localConfig && localConfig === 'Y') {
				this.darkMode = true
				this.turnOnDarkMode()
			}
			else {
				this.darkMode = false
			}
		},

		turnOnDarkMode () {
			this.$vuetify.theme.dark = true
			localStorage.setItem(config.localStorageKey.darkMode, 'Y');
			this.darkMode = true
		},

		turnOffDarkMode () {
			this.$vuetify.theme.dark = false
			localStorage.removeItem(config.localStorageKey.darkMode)
			this.darkMode = false
		},

		switchDarkMode () {
			// console.log('switchDarkMode')
			if (this.darkMode === true) {
				this.turnOffDarkMode()
			}
			else {
				this.turnOnDarkMode()
			}
		},

		getLocale () {
			const localStored = localStorage.getItem(config.localStorageKey.locale)
			if (localStored) {
				return localStored
			}
			else {
				let systemLange = navigator.language || navigator.browserLanguage || navigator.userLanguage
				if (systemLange) {
					systemLange = systemLange.toLowerCase()
					const lang = config.i18n.find(
					item =>
						item.locale === systemLange ||
						item.aliases.some(alias => alias === systemLange)
					)
					if (lang) {
						return lang.locale
					}
					else {
						return this.config.defaultLocale
					}
				}
				else {
					return this.config.defaultLocale
				}
			}
		},
		setLocale(locale) {
			locale = locale.toLowerCase()
			localStorage.setItem(config.localStorageKey.locale, locale)
			this.$i18n.locale = locale
			this.locale = locale
			this.langDisplay = this.getLangDisplay()
		},
		getLangDisplay: function () {
			let val = ''
			for (let item of config.i18n) {
				if (item.locale === this.locale) {
					val = item.langDisplay
					return val
				}
			}
			return val
		},

		showSiteNotification() {
      this.$emit("show-site-notification")
    },

	},
	created () {
		if (this.isMobile) {
			this.drawer = false
		}
		else {
			this.drawer = true
		}
		this.checkDarkMode()
		this.locale = this.getLocale()
		this.$i18n.locale = this.locale
		this.langDisplay = this.getLangDisplay()
	},
}
</script>

<style scoped>
.drawer-link-icon {
	margin-right: 10px !important;
}
.navbar-link {
	color: #CCC !important;
	text-decoration: none;
	font-size: 14px;
}
.nav-draw-link {
	/*color: #444 !important;*/
}
.testnet-name {
	padding: 10px;
	background-color: #e5f376;
	color: #424242;
	border-radius: 3px;
}
</style>
